"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLD_BP_CHECKOUT_PAGE = exports.OLD_CHECKOUT_PAGE = exports.NEW_ADDRESS_PAGE = exports.CHECKOUT_PAGE = exports.CART_PAGE = void 0;
exports.CART_PAGE = '/cart';
exports.CHECKOUT_PAGE = '/checkout';
exports.NEW_ADDRESS_PAGE = `/new-address`;
exports.OLD_CHECKOUT_PAGE = `/cart/Command/Validate`;
exports.OLD_BP_CHECKOUT_PAGE = `/cart/Marketplace/Delivery`;
